module.exports = __webpack_public_path__ + "odinstatic/v6.4.0/media/pricing.40d2e7bd.svg";